import LOGO from '../images/sooki-logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import HEADER from "../Components/header";
import BACK from '../images/icon-back-b.svg';
import baseUrlApi from '../lib/baseUrlApi';
import Utility from "../Consts/Utility";
import {ApiRequest} from "../Consts/ApiRequest";
import {useCookies} from "react-cookie";

type SiteAdminInputs = {
  siteId: string;
  siteRecno: string,
  gatewayCount: number,
  gateways: [
    {
      gatewayId: string,
      gatewayRecno: string,
      controlId: string,
      contactEnd: string,
      sensors: [
        {
          sensorRecno: number,
          sensorId: string,
          sensorName: string,
          sensorKind: number
        }
      ],
      sitePass: {
        admin: string;
        user: string;
      },
    }
  ]
};

const SiteList = () => {
  const navigate = useNavigate();
  const [siteAdminData, setSiteAdminData] = useState<SiteAdminInputs[]>([]);
  const [siteId, setSiteId] = useState<string>("");
  const [gatewayId, setGatewayID] = useState<string>("");
  const [sensorId, setSensorID] = useState<string>("");
  const [admin, setAdmin] = useState<string>("");
  const [user, setUser] = useState<string>("");
  const [gatewayCount, setGatewayCount] = useState<number>(0);
  const [contactEnd, setContactEnd] = useState<string>("");
  const { register, handleSubmit, formState: { errors } } = useForm<SiteAdminInputs>();
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

  let defaultParams = {
    "prcKind": 0,
    "siteRecno": "",
    "siteId": "",
    "sitePass": {
      "admin": "",
      "user": ""
    },
    "deviceInfo": {
      "gatewayID": "",
      "controlID": "",
      "sensorID": "",
      "contactEnd": "",
    },
    "contactEnd": "",
    "sensorID": ""
  };

  function errorCallback(error:any){
    if (error.response && error.response.status === 401) {
      console.error("Error token error:", error);
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    console.error("Error fetching dataSite:", error);
  }

  useEffect(() => {
    if(cookies.authority == 2 || cookies.authority == 3 || cookies.authority == 4) {
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    const token = cookies.access_token || "";
    ApiRequest.getSite(defaultParams, token, (response: any) => {
      console.log(response.data.sites);
      setSiteAdminData(response.data.sites);
    }, (error:any) => {
      errorCallback(error);
    });
  }, []);

  const onSubmit: SubmitHandler<SiteAdminInputs> = async (data) => {
    try {
      let params = {
        prcKind: 1,
        siteId: siteId,
        sitePass: {
          admin: admin,
          user: user,
        },
        deviceInfo: {
          gatewayID: gatewayId,
          controlID: gatewayId,
          sensorID: sensorId,
        },
        contactEnd: Utility.ReformatDate(contactEnd),
        sensorID: sensorId,
      };
      const token = cookies.access_token || "";
      ApiRequest.getSite(params, token, (response: any) => {
        console.log(response);
        setSiteAdminData(response.data.sites);
      }, (error:any) => {
        errorCallback(error);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div className="wrapper">
        <HEADER />
        <main className="main">
          <section className="page-head" id="page-head">
            <div className="page-head-block">
              <div className="page-name">
                <a onClick={() => navigate(-1)}><img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" /></a>
                <div className="page-name-label">現場一覧画面</div>
              </div>
            </div>
          </section>
          <section className="page-body scroll-block">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="search-box">
                <div className="search-box-elm">
                  <div className="search-box-elm-name">現場ID</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={siteId}
                      placeholder="siteID"
                      {...register("siteId",)
                      }
                      className="col-320 "
                      onChange={e => setSiteId(e.target.value)}
                    />
                    {errors.siteId && <p className="error-msg">{errors.siteId.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">Gateway管理番号</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={gatewayId}
                      placeholder="gatewayId"
                      {...register("gateways.0.gatewayId")}
                      className="col-320 "
                      onChange={e => setGatewayID(e.target.value)}
                    />
                    {errors.siteId && <p className="error-msg">{errors.siteId.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">センサ管理番号</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={sensorId}
                      placeholder="sensorId"
                      {...register("gateways.0.sensors.0.sensorId")}
                      className="col-320 "
                      onChange={e => setSensorID(e.target.value)}
                    />
                    {errors.siteId && <p className="error-msg">{errors.siteId.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">契約終了日</div>
                  <div className="search-box-elm-input">
                    <input
                      type="date"
                      value={contactEnd}
                      placeholder="user"
                      min="0000-01-01"
                      max="9999-12-31"
                      {...register("gateways.0.contactEnd",)
                      }
                      className="col-320 "
                      onChange={e => setContactEnd(e.target.value)}
                    />
                  </div>
                </div>
                <div className="search-box-btn">
                  <button className="btn btn-white-line">
                    <i className="icon-search-w"></i>検索</button>
                </div>
              </div>
            </form>

            <div className="table-box">
              <table className="st-table">
                <thead>
                  <tr>
                    <th className="">現場ID</th>
                    <th className="">Gateway管理番号</th>
                    <th className="">センサ管理番号</th>
                    <th className="">管理パスワード</th>
                    <th className="">閲覧パスワード</th>
                    <th className="">契約終了日</th>
                  </tr>
                </thead>
                <tbody>

                  {siteAdminData.map((site, siteIndex) => {
                     let sameSite = false;
                     return site.gateways?.map((gateway, gatewayIndex) => {
                          let sameGw = false;
                          return gateway.sensors?.map((sensor, sensorIndex) => {
                            let html =(<tr key={siteIndex *100 + gatewayIndex * 10 + sensorIndex}>
                            {/* <td>{siteIndex}{gatewayIndex}{sensorIndex}</td> */}
                              <td className="nowrap">
                                <Link to={`/gateway_sensor/${site?.siteId}/${site?.siteRecno}`} className="list-link">
                                  {(site.siteId && !sameSite) ? site.siteId : '-'}
                                </Link>
                              </td>
                              <td className="nowrap">
                                {(gateway && !sameGw) ? gateway.gatewayId : '-'}
                              </td>
                              <td className="nowrap">
                                {gateway && sensor && sensor ? sensor.sensorId : '-'}
                              </td>
                              <td className="nowrap">
                                {(gateway && gateway.sitePass.admin && !sameSite) ? gateway.sitePass.admin : '-'}
                              </td>
                              <td className="nowrap">
                                {(gateway && gateway.sitePass.user && !sameSite) ? gateway.sitePass.user : '-'}
                              </td>
                              <td className="nowrap">
                                {(gateway && !sameGw) ? gateway.contactEnd : '-'}
                              </td>
                            </tr>)

                            { sameSite  = true }
                            { sameGw = true}
                            return html;
                          })
                        })
                })}
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>
    </>
  )
};

export default SiteList;
